import { useState, createContext } from 'react';

export const SidebarContext = createContext({});

export const SidebarProvider = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [success, setSuccess] = useState(false);
  const [toggle, setToggle] = useState(false);
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };
  const successContext = () => {
    setSuccess(!success);
  };

  return (
    <SidebarContext.Provider value={{ sidebarToggle, toggleSidebar, closeSidebar, success,setSuccess, successContext, toggle, setToggle }}>
      {children}
    </SidebarContext.Provider>
  );
};
